import React, { useEffect, useRef, useState } from "react";
import { apiURL } from "../../config";
import { useSelector, useDispatch } from "react-redux";
import { setModels } from "../../redux/modelsSlice";
import { setModel } from "../../redux/modelSlice";
import ModelDropDown from "./ModelDropDown";

function ModelSelect() {
  const models = useSelector((state) => state.models);
  const model = useSelector((state) => state.model);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const dropDownDivRef = useRef(null);
  const [dropDownHeight, setDropDownHeight] = useState("");

  // get model updates from api server
  useEffect(() => {
    let ignore = false;
    const fetchModels = async () => {
      console.log("fetching models");
      try {
        const res = await fetch(`${apiURL}/api/models`, {
          credentials: "include",
        });
        const data = await res.json();
        if (!ignore) {
          dispatch(setModels(data.models));
          dispatch(setModel(Object.keys(data.models)[0]));
        }
      } catch (error) {
        console.log("Error fetching model: ", error);
      }
    };
    fetchModels();
    return () => {
      ignore = true;
    };
  }, [dispatch]); // only run once

  // when click outside the dropdown, hide the dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropDownDivRef.current &&
        !dropDownDivRef.current.contains(event.target)
      ) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropDownDivRef]);

  const handleClick = () => {
    if (dropDownDivRef.current) {
      const rect = dropDownDivRef.current.getBoundingClientRect();
      const spaceBelow = Math.floor(window.innerHeight - rect.bottom - 10);
      setDropDownHeight(`${spaceBelow}px`);
    }
    setShow(!show);
  };

  return (
    <div
      className="relative select-none h-9"
      onClick={handleClick}
      ref={dropDownDivRef}
    >
      <div className="flex relative items-center  text-white text-sm px-2  h-full bg-[hsla(var(--bg-300))] rounded-md hover:bg-gray-700 hover:text-white cursor-pointer transition border-[1px] border-[hsla(var(--border-100))]">
        {models[model]?.longName ?? "None"}
        <ArrowDown />
      </div>
      <ModelDropDown
        show={show}
        setShow={setShow}
        dropDownHeight={dropDownHeight}
        position="panel"
      />
    </div>
  );
}

const ArrowDown = function () {
  return (
    <div className="absolute right-4 top-[57%] -translate-y-1/2">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M19 9L14 14.1599C13.7429 14.4323 13.4329 14.6493 13.089 14.7976C12.7451 14.9459 12.3745 15.0225 12 15.0225C11.6255 15.0225 11.2549 14.9459 10.9109 14.7976C10.567 14.6493 10.2571 14.4323 10 14.1599L5 9"
            stroke="hsla(var(--text-100)/0.8)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
        </g>
      </svg>
    </div>
  );
};

export default ModelSelect;
